import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { UppdragListPage } from "pages/app/uppdrag-list-page/UppdragListPage";
import { UppdragStatus } from "types/uppdrag.type";
import { getUppdragList } from "api/uppdrag.api";

const LIMIT = 20;

const uppdragListSearchSchema = z.object({
  direction: z.enum(["ASC", "DESC"]).optional().catch("ASC"),
  sortby: z
    .enum(["customerName", "scheduleDate", "status", "assignedToUser", "id"])
    .optional()
    .catch("status"),
  search: z.string().optional().catch(undefined),
  nv: z.enum(["true", "false"]).optional().catch("false"),
  bilagor: z.enum(["true", "false"]).optional().catch("false"),
  fakturering: z.enum(["true", "false"]).optional().catch("false"),
  statuses: z.array(z.nativeEnum(UppdragStatus)).optional().catch([]),
  page: z.number().int().positive().optional().catch(1),
  selectedUppdrag: z.string().optional().catch(undefined),
});

export const Route = createFileRoute("/_authenticated/app/uppdrag/")({
  validateSearch: uppdragListSearchSchema,
  beforeLoad: async ({ context: { queryClient }, search }) => {
    const {
      direction,
      sortby,
      search: searchQuery,
      nv,
      bilagor,
      fakturering,
      statuses,
      page,
    } = search;

    await queryClient.ensureQueryData(
      getUppdragList({
        sortBy: sortby,
        direction,
        statuses,
        searchQuery,
        isWaitingForNvReport: nv === "true",
        limit: LIMIT,
        offset: LIMIT * ((page ?? 1) - 1),
        isWaitingForBilagor: bilagor === "true",
        isWaitingForInvoicing: fakturering === "true",
      }),
    );
  },
  component: UppdragListPage,
});
